import { render, staticRenderFns } from "./informacion_tipo_reportes.vue?vue&type=template&id=78910532&scoped=true"
import script from "./informacion_tipo_reportes.vue?vue&type=script&lang=js"
export * from "./informacion_tipo_reportes.vue?vue&type=script&lang=js"
import style0 from "./informacion_tipo_reportes.vue?vue&type=style&index=0&id=78910532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78910532",
  null
  
)

export default component.exports